import { h } from '@shared/ui/dom.js';
import { urlImagem } from '@shared/lib/arquivos.js';
import { iniciais } from '@shared/lib/formato.js';
import { paraTexto } from '@shared/lib/valores.js';

/**
 * Retrato de uma pessoa.
 *
 * ACEITA O NOME OU A PESSOA INTEIRA, e a diferenca decide o que aparece. Com uma
 * string so' ha' o disco de iniciais - e' o caso de quem chama sem ter o caminho
 * da foto em maos; com o objeto vem tambem `Imagem`, o caminho da foto no
 * servidor, e ai' o disco da' lugar ao retrato de verdade.
 *
 * O disco NAO E' um estado de erro: e' a forma que a pessoa sem foto tem na
 * tela. Numa lista de elenco (competicoes/clube-atletas.js) a maioria nao tem
 * retrato, e e' ele que mantem a fila alinhada em vez de abrir buracos.
 *
 * Foi assim que a promessa que estava escrita aqui se cumpriu: a funcao sempre
 * foi o ponto unico de troca, entao o cabecalho, a barra lateral, a nav inferior
 * e o perfil ganharam a foto sem que nenhum deles precisasse saber que ela
 * existe - so' passaram a mandar o usuario em vez do nome dele.
 *
 * `Imagem` NAO E' UMA URL: e' caminho de arquivo no servidor, e quem o
 * transforma em endereco e' o urlImagem - mesmo caminho do escudo do clube.
 *
 * O tamanho da letra sai do diametro (0,38), e nao de um token: o mesmo disco
 * serve de 22px na nav a 56px no perfil, e `em` mediria a fonte do PAI, nao a
 * caixa.
 */
export function avatarUsuario(quem, { tamanho = 32 } = {}) {
    const ehNome = typeof quem === 'string';
    const nome = ehNome ? quem : paraTexto(quem?.Nome ?? quem?.nome);
    const url = ehNome ? '' : urlImagem(quem?.Imagem ?? quem?.imagem);
    const estilo = { width: `${tamanho}px`, height: `${tamanho}px`, fontSize: `${Math.round(tamanho * 0.38)}px` };

    if (!url) return disco(nome, estilo);

    const img = h('img', {
        class: 'avatar avatar--foto',
        src: url,
        alt: '',
        width: tamanho,
        height: tamanho,
        loading: 'lazy',
        decoding: 'async',
        style: estilo,
    });

    //Mesma rede do escudo: foto que nao baixa cai no disco, sem deixar o icone
    //quebrado do browser aparecer no lugar do rosto.
    img.addEventListener('error', () => img.replaceWith(disco(nome, estilo)));

    return img;
}

const disco = (nome, estilo) => h('span', { class: 'avatar', style: estilo, 'aria-hidden': 'true' }, iniciais(nome));
